module.exports = __webpack_public_path__ + "static/filip2-61e684687e4f73d1556d1cd4a5c8a75a.jpg";